import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Cookies } from 'react-cookie';
import { ReactHeight } from 'react-height';
import _ from 'lodash';
// import {arrayOf, number, bool, string, func, object} from 'prop-types';
import cdphpLogo from '../../assets/logo.svg';

import StartOverIcon from './StartOverIcon.jsx';
import MyQuoteButton from '../../components/Header/MyQuoteButton.jsx';

class Header extends Component {
  constructor (props) {
    super(props);
    const cookies = new Cookies();
    this._handleStartOver = this._handleStartOver.bind(this);
    this.state = {
      quoteId: cookies.get('CDPHP_quoteString')
    };
  }

  _handleStartOver (e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.handleLogoClick();
    return false;
  }

  render () {
    const {
      inQuiz,
      inResults,
      scroll,
      route,
      getHeaderHeight,
      handleShowStartOverModal,
      properties
    } = _.clone(this.props);

    const s = _.clone(this.state);
    let theRoute = route === 'medicare-western-ny' ? 'medicare' : route;
    const linkRoute = (route === '/' ? '/find-a-plan/start' : '/' + theRoute + '/find-a-plan/start');
    const medicareCompare = (route === 'medicare-compare' || route === 'medicare-compare-western-ny');

    const {
      phone,
      topBanner,
      hours,
      premium,
      scrollButton
    } = properties;

    let phoneLink;
    let headerClasses = '';

    if (phone.indexOf('|') > -1) phoneLink = '866-692-3747';
    else if (phone.indexOf('MY-CDPHP') > -1) phoneLink = '866-692-3747';
    else phoneLink = phone;

    if (scroll && _.isString(scroll)) headerClasses += ' scroll';
    if (inQuiz || inResults || medicareCompare) headerClasses += ' locked';
    if (s.quoteId) headerClasses += ' myResults';

    return (
      <header className={headerClasses}>
        <ReactHeight onHeightReady={height => getHeaderHeight ? getHeaderHeight(height) : null}>
          {topBanner}
          <div className='main'>
            <p><strong><a href={'tel:' + phoneLink} className='tel phoneswap'>{phone}</a></strong> <span>{hours}</span></p>
            <Link to={{pathname: 'javascript:void();'}} className='logo' onClick={this._handleStartOver}
            ><img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' /></Link>

            {!inQuiz && !inResults && !s.quoteId && <Link
              to={linkRoute}
              className='btn'
              replace={false}
            >Find a Plan</Link>}
            {premium}
            {inResults && <StartOverIcon
              handleShowStartOverModal={handleShowStartOverModal}
            />}
            {!inResults && !inQuiz && s.quoteId && <MyQuoteButton text={'My Quote'} quoteId={s.quoteId} />}
            {scrollButton}
          </div>
        </ReactHeight>
      </header>
    );
  }
}

Header.propTypes = { // validate props expected
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx